import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axiosInstance from "../../api/axiosInstance";

// Mock Data for now
const mockData = [
    {
        firstName: "Robert",
        lastName: "Allen",
        email: "robertallen@gmail.com",
        phone: "0987456321",
        status: "Active",
        message: "Lorem ipsum is a dummy ...",
    },
    {
        firstName: "Roshan",
        lastName: "Srivastava",
        email: "roshan@gmail.com",
        phone: "0987456321",
        status: "Pending",
        message: "Lorem ipsum is a dummy ...",
    },
    {
        firstName: "Kshitij",
        lastName: "Kapoor",
        email: "kshitij@gmail.com",
        phone: "0987456321",
        status: "Completed",
        message: "Lorem ipsum is a dummy ...",
    },
];

// Async Thunk
export const fetchContactUsData = createAsyncThunk(
    "contactUs/fetchContactUsData",
    async (_, { rejectWithValue }) => {
        try {
            // === FUTURE Real API Call ===
            // const response = await axiosInstance.get("PASTE_YOUR_API_URL_HERE");
            // return response.data?.data || response.data;
            // ===========================

            // Simulating API call
            await new Promise((resolve) => setTimeout(resolve, 800));
            return mockData;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch contact us data."
            );
        }
    }
);

const initialState = {
    contacts: [],
    loading: false,
    error: null,
};

const contactUsSlice = createSlice({
    name: "contactUs",
    initialState,
    reducers: {
        // Synchronous actions can go here
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContactUsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchContactUsData.fulfilled, (state, action) => {
                state.loading = false;
                state.contacts = action.payload;
                state.error = null;
            })
            .addCase(fetchContactUsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default contactUsSlice.reducer;
